
const mvSwiper = new Swiper('.fv-swiper', {
  // Optional parameters
  loop: true,
  effect: 'fade',
  speed: 1000,
  slidesPerView: 1,
  spaceBetween: 0,
  // autoplay: {
  //     // delay: 5000,
  // },
  autoplay: false,
  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  // Navigation arrows
navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

$(function () {
  setTimeout(function () {
    $(".c_first-view__logo").fadeOut(1000);
    mvSwiper.params.autoplay.delay = 5000; // 自動再生の遅延設定
    mvSwiper.autoplay.start();
  }, 4000);
});

$(document).ready(function() {
  function adjustFirstViewHeight() {
      var windowHeight = $(window).height();
      var announcementBarHeight = $(".announcement-bar-section").outerHeight(true);
      var sectionHeaderHeight = $(".section-header").outerHeight(true);
      var firstViewHeight = windowHeight - announcementBarHeight - sectionHeaderHeight;
      $(".c_first-view").css("height", firstViewHeight + "px");
      $(".fv-swiper").css("height", firstViewHeight + "px");
  }

  // 最初の高さを設定
  adjustFirstViewHeight();

  // ウィンドウのリサイズ時に高さを調整
  $(window).resize(function() {
      adjustFirstViewHeight();
  });
});
